import iceCreamImage from "./images/iceCream.png";
import sugarDonutsImage from "./images/sugarDonuts.png";
import donutTrayImage from "./images/donutTray.png";
import candyflossImage from "./images/candyfloss.png";
import largeTwistLollipopImage from "./images/largeTwistLollipop.png";
import roundWheelLollipopImage from "./images/roundWheelLollipop.png";
import redAndBlueLollipopsImage from "./images/redAndBlueLollipops.png";
import popcornImage from "./images/popcorn.png";
import smileyFaceBallImage from "./images/smileyBall.png";
// import ledWindmillImage from "./images/ledWindmill.png";
import bubbleWandImage from "./images/bubbleWand2.png";
// import frozenWandImage from "./images/frozenWand.png";
import slushImage from "./images/slush.png";

export const donuts = [
  {
    type: "variable",
    name: "Sugar Donuts",
    image: sugarDonutsImage,
    description: "Freshly made hot sugar donuts",
    variants: [
      { name: "1 Donut £1.10", price: 1.1, soldOut: false },
      /*{ name: "3 Donuts £3.10", price: 3.1, soldOut: false },*/
      { name: "5 Donuts £5.00", price: 5.0, soldOut: false }
    ]
  },
  {
    type: "variable",
    name: "Deluxe Donut Tray",
    image: donutTrayImage,
    description: "Freshly made tray of 5 hot donuts with toppings and sauce",
    variants: [
      { name: "Biscoff Crumbs & Biscoff Sauce £6.00", price: 6, soldOut: false },
      { name: "Raspberry & White Chocolate £6.00", price: 6, soldOut: false },
      { name: "Oreo & Milk Chocolate £6.00", price: 6, soldOut: false }
    ]
  }
];

export const drinks = [
  /*
  {
    type: "variable",
    name: "Tea",
    description: "Yorkshire Tea, Let's have a proper brew!",
    image: teaImage,
    masterPrice: 1.6,
    variants: [{ name: "Decaf also available", soldOut: false }]
  },
  {
    type: "variable",
    name: "Coffee",
    description: "NESCAFE Azera Americano",
    image: coffeeImage,
    masterPrice: 2.6,
    variants: [{ name: "Decaf also available", soldOut: false }]
  },
  {
    type: "normal",
    name: "Hot Chocolate",
    description: "Cadburys Hot Chocolate with real dairy squirty cream and marshmallows",
    price: 2.8,
    image: hotChocolateImage,
    soldOut: false
  },
  /*
  {
    type: "variable",
    name: "Flavouring Syrups",
    image: moninImage,
    description: "These can be added to your coffee or hot chocolate",
    masterPrice: 0.5,
    variants: [
      { name: "Caramel", soldOut: false },
      { name: "Vanilla", soldOut: false },
      { name: "Gingerbread", soldOut: false },
      { name: "Cinnamon Roll", soldOut: false },
      { name: "Hazelnut", soldOut: false }
    ]
  },*/
  {
    type: "variable",
    name: "Slush",
    image: slushImage,
    description: "Mango, Bubblegum or Sour Apple & Cherry",
    variants: [
      { name: "Regular £2.20", price: 2.0, soldOut: false },
      { name: "Large £2.70", price: 2.5, soldOut: false }
    ]
  }, /*
  {
    type: "variable",
    name: "Cold Drinks",
    image: cansImage,
    variants: [
      { name: "Cans £1.30", soldOut: false },
      { name: "Bottled Water £1.00", soldOut: false }
    ]
  } */
  
];

export const icecream = [
  {
    type: "variable",
    name: "Ice Cream",
    image: iceCreamImage,
    description: "Choice of 2 toppings and any sauces",
    variants: [
      { name: "Regular £2.90", price: 2.8, soldOut: false },
      { name: "Large £3.50", price: 3.5, soldOut: false }
      /* { name: "Dubai Chocolate £4.00", price: 3.5, soldOut: false } */
    ]
  }
  // { type: "normal", name: "Ice Pops", description: "Blue raspberry, Cherry, Green apple or Watermelon", price: 0.7, image: icePopsImage, soldOut: false }
  /* { type: "normal", name: "Holly Jolly Pie", description: "Crumbled mince pie with a golden caramel sauce", price: 3.5, image: iceCreamImage, soldOut: false } */
];

export const candyfloss = [
  {
    type: "variable",
    name: "Candyfloss",
    image: candyflossImage,
    description: "Pink Vanilla or Blue Raspberry",
    variants: [
      { name: "Bag £2.50", price: 2.5, soldOut: false },
      { name: "Large Tub £3.30", price: 3.3, soldOut: false }
    ]
  }
];

export const lollipops = [
  { type: "normal", name: "Giant Rainbow Twist Lollipop", price: 2.8, image: largeTwistLollipopImage, soldOut: false },
  { type: "normal", name: "Giant Rainbow Wheel Lollipop", price: 2.8, image: roundWheelLollipopImage, soldOut: false },
  { type: "normal", name: "Strawberry & Bubblegum Wheel Lollipop", price: 2.5, image: redAndBlueLollipopsImage, soldOut: false },
  /*{ type: "normal", name: "Sugar Dummies", price: 2.0, image: sugarDummyImage, soldOut: false }*/
];

export const sweetTreats = [...candyfloss, ...lollipops];

export const snacks = [
  /*
  {
    type: "variable",
    name: "Crisps",
    image: crispsImage,
    masterPrice: 1.2,
    variants: [
      { name: "Ready Salted", soldOut: false },
      { name: "Salt & Vinegar", soldOut: false },
      { name: "Cheese & Onion", soldOut: false },
      { name: "Quavers", soldOut: false },
      { name: "Wotsits", soldOut: false }
    ]
  },
  */
  {
    type: "variable",
    name: "Popcorn",
    description: "Freshly made cinema style sweet popcorn",
    image: popcornImage,
    variants: [
      { name: "Bag £2.50", price: 2.5, soldOut: false },
      { name: "Tub £3.30", price: 3.3, soldOut: false }
    ]
  }
];

export const bubbleWands = [
  { type: "normal", name: "Bubble Wand", price: 2.0, image: bubbleWandImage, soldOut: false }
];

export const toys = [
  /*
  { type: "normal", name: "Mini Disco Ball", price: 3.0, image: miniDiscoBall, soldOut: false },
  { type: "normal", name: "Flashing Foam Stick", price: 3.0, image: flashingFoamStick, soldOut: false },
  */
  { type: "normal", name: "Scented Balls", price: 2.8, image: smileyFaceBallImage, soldOut: false },
  // { type: "normal", name: "LED Windmill", price: 3.5, image: ledWindmillImage, soldOut: false },
  ...bubbleWands,
  // { type: "normal", name: "Frozen Wand", price: 4, image: frozenWandImage, soldOut: false },
];

export const menuCategories = [
  { key: "donuts", title: "Donuts", products: donuts },
  { key: "snacks", title: "Snacks", products: snacks },
  { key: "icecream", title: "Ice Cream", products: icecream },
  { key: "sweetTreats", title: "Sweet Treats", products: sweetTreats },
  { key: "toys", title: "Novelty Toys", products: toys },
  { key: "drinks", title: "Drinks", products: drinks }
];
